import React from 'react'
import { WrappedFieldProps } from 'redux-form'
import { ISelectInputProps } from './Select'

type C = React.ComponentType<ISelectInputProps>

function withRedux(Component: C) {
  return function({
    input,
    meta,
    children,
    ...rest
  }: WrappedFieldProps & ISelectInputProps) {
    return (
      <Component
        name={input.name}
        value={input.value}
        onChange={input.onChange}
        // onBlur={input.onBlur}
        errorMsg={meta.error}
        warningMsg={meta.warning}
        isValidating={meta.asyncValidating}
        {...rest}
      >
        {children}
      </Component>
    )
  }
}

export default withRedux
